/* ============
 * Actions for the exteriors module
 * ============
 *
 * The actions that are available on the
 * exteriors module.
 */

import axios from 'axios';
import { apiEndpointConst, authHeader } from '@/utils/urls';
import * as types from './mutation-types';

const apiEndpoint = (order, lang) => {
  let result = `/api-proxy/${order}/data/exterior${lang
    ? `?lang=${lang}`
    : ''}`;

  if (process.env.NODE_ENV === 'production') {
    result = apiEndpointConst(order, 'exterior', lang ? `?lang=${lang}` : '');
  }

  return result;
};

export const load = ({ commit }, { order, lang }) =>
  axios
    .get(apiEndpoint(order, lang), { headers: authHeader })
    .then((res) => {
      commit(types.LOAD, res.data);
      return res.data;
    });
export const toggleShowOverlayStatus = ({ commit }, value) => {
  commit(types.TOGGLE_SHOW_OVERLAY_STATUS, value);
};

const apiEndpointForPOI = (id) => {
  let result = `/api/v1/poi/${id}?access_token=b5207eb87640a014da2a5c7b76334e98`
  if (process.env.NODE_ENV !== 'production') {
    result = 'https://staging.pixerymedia.com' + result;
  }
  return result
}
export const getPoi = ({ commit }, id) =>
  axios
    .get(apiEndpointForPOI(id), { headers: authHeader })
    .then((res) => {
      commit(types.SET_POI_LIST, res.data);
    });

export const isShownTogglePOI = ({commit}, isShown) => {
  commit(types.TOGGLE_POI, isShown)
}
export const togglePoiMask = ({commit}, show) => {
  commit(types.TOGGLE_POI_MASK, show)
}
export default {
  load,
  getPoi,
  toggleShowOverlayStatus,
  isShownTogglePOI,
  togglePoiMask,
};
